(() => {
  const bootstrapFunction = (params) => new Promise((resolve, reject) => {
    function init() {
      if (!window.swinger.app || window.swinger.app === bootstrapFunction) {
        window.setTimeout(() => {
          init();
        }, 100);
        return;
      }
      window.swinger.app(params)
        .then((result) => {
          resolve(result);
        })
        .catch((e) => {
          reject(e);
        });
    }

    init();
  });

  window.swinger = { ...window.swinger, app: bootstrapFunction };
})();
